module.exports = __webpack_public_path__ + "static/media/chevron-right.53a6e874.svg";